import type { IntakeLine } from '../api/types'

/** Shared chip variant/label for a line's `mapping_source` — used by the
 *  editable grid (work-view page) and the read-only inline table preview. */
export function lineMatchChip(
  line: IntakeLine,
): { variant: 'success' | 'warning' | 'danger' | 'neutral'; label: string } {
  const variant: 'success' | 'warning' | 'danger' | 'neutral' =
    line.mapping_source === 'unmatched'
      ? 'danger'
      : line.mapping_source === 'manual'
        ? 'success'
        : line.mapping_source === 'pricelist'
          ? 'success'
          : 'warning'
  const label =
    line.mapping_source === 'pricelist'
      ? 'Pricelist'
      : line.mapping_source === 'mappings_table'
        ? 'Mapping'
        : line.mapping_source === 'history'
          ? 'History'
          : line.mapping_source === 'manual'
            ? 'Manual'
            : 'Unmatched'
  return { variant, label }
}
